import React from "react";
import { motion } from "framer-motion";

const ServicesHeading = (props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true, delay: 0.5, amount: 0.25 }}
    >
      <h2 className="text-[24px] leading-7 tab:text-[26px] lg:text-[36px] lg:leading-[40px] font-semibold text-white opacity-[0.9]">
        {props.headings.map((heading, index) => {
          if (index === props.headings.length - 1)
            return <span key={`heading-${index}`}>{heading}</span>;
          else {
            return (
              <>
                <span key={`heading-${index}`}>{heading}</span>
                <br />
              </>
            );
          }
        })}
      </h2>
    </motion.div>
  );
};

export default ServicesHeading;
